module.exports = __webpack_public_path__ + "static/media/development.7422941b.png";